
/* eslint-disable @typescript-eslint/camelcase */
import { defineAsyncComponent } from "vue";
import { Vue, Options } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import debounce from "lodash/debounce";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import convertDecimalWithComma from "@/app/infrastructures/misc/common-library/ConvertDecimalWithComma";
import { AccountController } from "@/app/ui/controllers/AccountController";
import router from "@/app/ui/router";
import { BalanceController } from "@/app/ui/controllers/BalanceController";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { ChipsStyles } from "@/app/ui/components/chips-v2/modules";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { InstantBookingController } from "@/app/ui/controllers/InstantBookingController";
import { ShipmentBooking } from "@/domain/entities/ShipmentBooking";
import { STIController } from "@/app/ui/controllers/STIController";
import { STISTTDueSummaryListRequest } from "@/data/payload/api/StiApiRequest";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import { FlagsPermissionPusatResolusiV2 } from "@/feature-flags/flags-pusat-resolusi-v2";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { paginationStyle } from "../../booking/booking-utils";
import ModalInstantBoookingConfirmation from "../../booking/component/modal-instant-booking-confirmation.vue";
import {
  formatByCountry,
  formatDateNormal
} from "@/app/infrastructures/misc/Utils";
import copy from "copy-text-to-clipboard";
import Notification from "@/app/ui/components/notification/index.vue";
import AdvancedFilter from "../components/advanced-filter.vue";
import {
  ApiRequestList,
  QueryParamsEntities2
} from "@/domain/entities/MainApp";
import Pill from "@/app/ui/components/pill/index.vue";
import mapProductTypeName from "@/app/infrastructures/misc/common-library/ProductTypeNameMapper";
import { PickupCorporateSummary } from "@/domain/entities/ListPickupV2";
import { ListPickupV2Controller } from "@/app/ui/controllers/ListPickupV2Controller";
import { PickupCorporateSummaryRequest } from "@/data/payload/api/ListPickupV2Request";
import { PickupRequestMode } from "../../../pickup/components/modal-request-pickup/types";
import { PickupSuccessPayload } from "../../../pickup/components/modal-request-pickup/types";
import ModalRequestPickup from "../../../pickup/components/modal-request-pickup/index.vue";
import ModalActivePickupWarning from "../../../pickup/components/modal-active-pickup-warning/index.vue";
import SavedAddressList from "../../../pickup/components/saved-address-list/index.vue";
import ModalPickupRequestSuccess from "../../../pickup/components/modal-pickup-request-success/index.vue";
import PickupBookingSummary from "../../../pickup/list-pickup-v2/components/pickup-booking-summary.vue";
import { PickupScheduleController } from "@/app/ui/controllers/PickupScheduleController";
import { PickupCorporateAddress } from "@/domain/entities/PickupSchedule";
import { AddressFormSuccessPayload } from "../../../pickup/components/saved-address-list/types";
import { patchPickupSummaryAddress } from "../../../pickup/list-pickup-v2/utils/patch-pickup-summary-address";
import { applyOngoingFilterToAdvanceFilterData, parseSummaryFilterQuery, PRESET_ONGOING } from "../../../pickup/utils/summary-filter-query";
import { GET_NESTED_STATUS_OPTIONS } from "../constants";
import { isEqual } from "lodash";
import ModalAddNewAddress from "../../../pickup/components/modal-add-new-address/index.vue";
import { FlagsPermissionBookingV4 } from "@/feature-flags/flag-booking-v4";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { InsuranceTypeDelivery } from "@/domain/entities/Booking";

const ModalErrorBalance = defineAsyncComponent({
  loader: () =>
    import("@/app/ui/views/shipment/booking/component/modal-error-balance.vue")
});
const DetailRejectPopup = defineAsyncComponent({
  loader: () =>
    import(
      "@/app/ui/views/shipment/booking/detail-booking/detail-reject-popup.vue"
    )
});

@Options({
  components: {
    DetailRejectPopup,
    OverlayPanel,
    ModalErrorBalance,
    ModalInstantBoookingConfirmation,
    Skeleton,
    CustomDropdown,
    Notification,
    AdvancedFilter,
    Pill,
    PickupBookingSummary,
    ModalRequestPickup,
    ModalActivePickupWarning,
    ModalPickupRequestSuccess,
    SavedAddressList,
    ModalAddNewAddress
  }
})
class TabListBooking extends Vue {
  get isDetailAble() {
    return FlagsPermissionBooking.permission_booking_view_detail.isEnabled();
  }
  get isAbleToCreateShipmentId() {
    return FlagsPermissionBookingV3.permission_booking_v3_create_markeplace.isEnabled();
  }
  get isCreateManualAble() {
    return FlagsPermissionBookingV3.permission_booking_v3_create_manual.isEnabled();
  }
  get isCreateForCorporateAble() {
    return (
      FlagsPermissionBookingV3.permission_booking_v3_create_markeplace.isEnabled() &&
      !this.dataProfile.isPosChildAccount
    );
  }
  get isAbleToCreateInstantBooking() {
    return FlagsPermissionBooking.permission_instant_booking_create.isEnabled();
  }
  get isAbleToAdvanceFilter() {
    return FlagsPermissionBooking.permission_advance_filter_client_partner_click.isEnabled();
  }

  formatPriceWithoutCurrency(price: number, currency: "IDR" | "MYR" = "IDR") {
    const country = currency === "MYR" ? "MY" : "ID";
    return formatByCountry(price, { type: "quantity", country });
  };

  tncModal = false;
  intervalId: any = "";
  get isMigratingFromElexys() {
    return process.env.VUE_APP_MIGRATE_FROM_ELEXYS === "true";
  }

  paginationStyle = paginationStyle;

  get isBookingEnable() {
    return FlagsPermissionBooking.permission_booking_enable.isEnabled();
  }
  get isBookingRetail() {
    return (
      AccountController.accountData.isPosAccount &&
      FlagsPermissionBookingV3.permission_booking_v3_create_manual.isEnabled()
    );
  }

  get isBookingRetailV4() {
    return (
      AccountController.accountData.isPosAccount &&
      FlagsPermissionBookingV4.permission_booking_v4_create_manual.isEnabled()
    );
  }

  get isBookingClient() {
    return AccountController.accountData.isPosAccount
      ? FlagsPermissionBookingV3.permission_booking_v3_create_client.isEnabled()
      : FlagsPermissionBookingV3.permission_booking_v3_create_manual.isEnabled();
  }

  get isBookingClientV4() {
    return AccountController.accountData.isPosAccount
      ? FlagsPermissionBookingV4.permission_booking_v4_create_client.isEnabled()
      : FlagsPermissionBookingV4.permission_booking_v4_create_manual.isEnabled();
  }

  phoneNumber = "";

  beforeMount() {
    this.fetchNeedStiSummary();
  }

  mounted() {
    this.onResetAdvancedFilter(true);
    this.phoneNumber = this.$route.query.phoneNumber?.toString() || "";
    this.onSetRefs();
    ShipmentBookingController.initShipmentBooking(this.phoneNumber);
    this.hydrateFromQuery();
    BalanceController.getBalance(true);
    this.fetchSummaryListPickupV2();
    if (this.isClient) {
      this.addressPrefetchPromise = this.updateListPickupCorporateAddress();
    }
    this.intervalId = setInterval(() => {
      this.fetchNeedStiSummary();
    }, 600000); // 600000 millisecond = 10 minute
  }

  unmounted(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    ShipmentBookingController.setSttCorporate(false);
  }

  handleButtonBookingV3(event: any) {
    this.goToCreateV3();
    this.openBookingOthers(event);
  }

  handleButtonBookingClientV3() {
    this.goToCreateClientV3();
    this.hitGtmBookingClicked();
  }

  handleButtonBookingV4(event: any) {
    this.goToCreateV4();
    this.openBookingOthers(event);
  }

  handleButtonBookingClientV4() {
    this.goToCreateClientV4();
    this.hitGtmBookingClicked();
  }

  get getPhoneNumber() {
    return this.phoneNumber;
  }

  onSetRefs() {
    this.refs = this.$refs;
  }

  get validationAccount() {
    return AccountController.validationAccount;
  }

  onRequest() {
    ShipmentBookingController.fetchShipmentBooking({ scoped: true });
  }

  get firstRequest() {
    return ShipmentBookingController.firstRequest;
  }

  get shipmentBooking() {
    return ShipmentBookingController.shipmentBookingData.data.map(
      (item: ShipmentBooking) => {
        return {
          ...item,
          customDeleteAction: this.isMigratingFromElexys
            ? false
            : this.isEditAbleBasedOnAccountType(item.sttLastStatusId)
        };
      }
    );
  }
  get isErrorList() {
    return !this.shipmentBooking.length && !this.isLoading;
  }
  get isEmpty() {
    const isAllEmpty = Object.values(this.advancedFilterData).every((v) =>
      Array.isArray(v) ? v.length === 0 : !v
    );

    return (
      isAllEmpty &&
      !this.searchValue &&
      !this.shipmentBooking.length &&
      !this.isLoading
    );
  }

  //Filter Search
  onSearch(value: string) {
    ShipmentBookingController.searchAction(value, true);
  }
  get searchValue() {
    return ShipmentBookingController.search;
  }
  clearSearch() {
    ShipmentBookingController.clear();
  }

  // advance filter
  isAdvancedFilterOpened = false;
  onChangeAdvancedFilter(event: any, flag?: { isFromLisPickup?: boolean }) {
    ShipmentBookingController.setAdvanceFilterData(event);
    this.onUpdateQuery(flag?.isFromLisPickup);
    if (this.pagination) {
      this.pagination.page = 1;
    }
    this.onRequest();
  }
  onOpenedAdvancedFilter(event: any) {
    this.isAdvancedFilterOpened = event;
  }
  onResetAdvancedFilter(isUnmount = false, flag?: { isViewStt?: boolean }) {
    ShipmentBookingController.setAdvanceFilterData({
      periodeStart: "",
      periodeEnd: "",
      originCode: "",
      destinationCode: "",
      clientPartnerId: "",
      status: "",
      product: [],
      COD: false,
      PAD: false,
      DFOD: false,
      asuransi: [],
      nestedStatus: []
    });
    if (this.pagination) {
      this.pagination.page = 1;
    }

    this.onResetQuery(flag?.isViewStt);

    if (!isUnmount) {
      this.onRequest();
    }
  }

  get advancedFilterData() {
    return ShipmentBookingController.advanceFilterData;
  }

  //Filter assesstment status
  sttAssessmentStatus: any = {};
  get sttAssessmentStatusData() {
    return [
      {
        name: this.$t("bookingShipment.list.filter.assessmentStatusAll"),
        value: ""
      },
      {
        name: this.$t("bookingShipment.list.filter.assessmentStatusWaiting"),
        value: "waiting"
      },
      {
        name: this.$t("bookingShipment.list.filter.assessmentStatusRejected"),
        value: "rejected"
      },
      {
        name: this.$t("bookingShipment.list.filter.assessmentStatusApproved"),
        value: "approved"
      }
    ];
  }

  onSelectSttAssessmentStatus(item: any) {
    this.sttAssessmentStatus = item.value;
    ShipmentBookingController.selectSttAssessmentStatusAction(item.value, true);
  }

  // Pagination Table
  get pagination() {
    return ShipmentBookingController.shipmentBookingData.pagination;
  }

  //Loading
  get isLoading() {
    return ShipmentBookingController.isLoading || BalanceController.isLoading;
  }

  get isLoadingSTTSummary() {
    return STIController.isLoadingSTTSummary;
  }

  //Error
  get isError() {
    return ShipmentBookingController.isError;
  }

  //Error Cause
  get errorCause() {
    return ShipmentBookingController.isErrorCause;
  }

  //misc
  modalInputShipmentId = false;
  refs: any = {};
  openBookingRetail(event: any) {
    this.onSetRefs();
    const refs: any = this.refs;
    refs["opBookingRetail"]?.toggle(event);
  }
  get isOpenBookingRetail() {
    return this.refs.opBookingRetail?.visible;
  }
  openBookingOthers(event: any) {
    this.onSetRefs();
    const refs: any = this.refs;
    refs["opBookingOthers"]?.toggle(event);
  }
  get isOpenBookingOthers() {
    return this.refs.opBookingOthers?.visible;
  }

  fetchNeedStiSummary() {
    if (this.isAccountPOS) {
      const payload = new STISTTDueSummaryListRequest({
        bookedId: AccountController.accountData.account_type_detail.id,
        bookedType: "pos"
      });

      STIController.getSTISTTDueSummary(payload);
    }
  }

  onRefreshSTISummary = debounce(() => {
    this.fetchNeedStiSummary();
  }, 250);

  get STISTTDueSummaryData() {
    return STIController.STISTTDueSummaryData;
  }

  gotoNeedToStiPage(isNow = false, isOverdue = false) {
    router.push({
      name: "need-to-sti-booking",
      query: { isNow: String(isNow), isOverdue: String(isOverdue) }
    });
  }

  get isAccountPOS() {
    return AccountController.accountData.isPosAccount;
  }

  get columnsOne() {
    return [
      {
        key: "actionable_column",
        name: `<div class='flex flex-col leading-5 justify-start'><span>${this.$t(
          "bookingShipment.list.table.noSttAndShipment"
        )}</span><span class='text-gray-lp-600 font-normal'>${this.$t(
          "bookingShipment.list.table.noShipment"
        )}</span></div>`,
        styleHead: "w-60 text-left whitespace-no-wrap",
        styleBody: "text-red-lp-200 text-center",
        render: (item: ShipmentBooking) => {
          return `
            <div class="flex flex-col leading-5">
              <div class="flex items-center space-x-1">
                <div class='text-left text-red-lp-100 underline'>
                  ${item.sttNo}
                </div>
                ${
                  item.sttIsCod
                    ? item.sttIsDfod
                      ? `<img src="${require("@/app/ui/assets/svg/new-dfod.svg")}" class="h-2.5" />`
                      : `<img src="${require("@/app/ui/assets/svg/new-cod.svg")}" class="h-2.5" />`
                    : ""
                }
              </div>
              ${
                item.sttShipmentId
                  ? `<div class="text-black-lp-300">${item.sttShipmentId}</div>`
                  : ""
              }
            </div>
        `;
        },
        onClickValueCell: this.goToDetail,
        showButton: () => true,
        icon: "copy-clipboard",
        iconStyle: "ml-1",
        iconColor: "red-lp-100",
        onClickValue: (item: ShipmentBooking) => {
          const result = copy(item.sttNo);
          if (result) {
            this.setNotification();
          }
        },
        iconTooltip: () => this.$t("bookingShipment.list.copySttNumber")
      }
    ];
  }

  get columnsTwo() {
    return [
      {
        name: this.$t("bookingShipment.list.table.lastStatus"),
        styleHead: "w-40 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="text-black-lp-300 flex">
                    <div class="rounded capitalize px-2 py-0 ${this.mapLastStatusColor(
                      item.sttLastStatusId
                    )}">
                        ${item.sttLastStatusId}
                    </div>
                  </div>`;
        },
        toolTip: (item: ShipmentBooking) => {
          if (item.sttLastStatusId === "CODREJ") {
            return `<div class='flex text-black-lp-300 text-12px max-w-xs'>${item.dexCodrejReason}</div>`;
          }
          if (item.sttLastStatusId === "DEX") {
            return `
              <div class="text-xs">
                <h5 class="text-gray-lp-300 font-semibold">${this.$t(
                  "onProcessStt.tooltip.dexAttempt"
                )} ${item.totalSttDex}</h5>
                <p class="text-gray-lp-600">${item.dexCodrejReason}</p>
              </div>
            `;
          }
        }
      },
      {
        name: this.$t("bookingShipment.list.table.destinationCity"),
        styleHead: "w-40 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="break-all text-black-lp-300 line-clamp-2" title="${item.sttDestinationCity} - ${item.sttDestinationCityName}">${item.sttDestinationCity} - ${item.sttDestinationCityName}</div>`;
        }
      }
    ];
  }

  get columnThree() {
    return [
      {
        name: `<div class='flex flex-col leading-5 justify-start'><span>${this.$t(
          "bookingShipment.list.table.serviceTypeAndChargeableWeight"
        )}</span><span class='text-gray-lp-600 font-normal'>${this.$t(
          "bookingShipment.list.table.chargeableWeight"
        )}</span></div>`,
        styleHead: "w-56 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="flex flex-col leading-5">
                    <div class="capitalize text-black-lp-300">
                      ${mapProductTypeName(item.sttProductType)}
                    </div>
                    <div class='text-gray-lp-600 font-normal'>
                      ${formatByCountry(item.sttChargeAbleWeight, {
                        type: "weight",
                        country: AccountController.accountData.countryCode?.toUpperCase()
                      })} kg
                    </div>
                  </div>`;
        }
      },
      {
        name: this.$t("bookingShipment.list.table.bookingDate"),
        styleHead: "w-64 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="text-black-lp-300">
                    ${formatDateNormal(
                      item.sttCreatedAt,
                      "DD MMMM YYYY, HH:mm"
                    )}
                    </div>
                    <div class="capitalize text-gray-lp-500">
                    ${ellipsisString(item.sttCreatedName || "-", 30)}
                  </div>`;
        }
      },
      {
        name: this.$t("bookingShipment.list.table.bookedFor"),
        styleHead: "w-64 text-left",
        render: (item: ShipmentBooking) => {
          return `<div class="text-black-lp-300 line-clamp-2">${item.sttBookedForName ||
            "-"}</div>`;
        },
        vtooltip: (item: ShipmentBooking) => item.sttBookedForName
      }
    ];
  }

  get columnAction() {
    return [
      {
        name: this.$t("bookingShipment.list.table.atur"),
        key: "button_column",
        styleHead: "w-24 justify-center",
        styleButton: (item: ShipmentBooking) => {
          const groupOptions = [
            {
              icon: "duplicate",
              iconV2: true,
              id: "retail",
              label: this.$t("bookingShipmentV2.action.duplicateRetail"),
              textColor: "gray-lp-300",
              iconColor: "gray-lp-600",
              sizeIcon: "w-5",
              clickFunction: () => {
                if (
                  item.bookingFormVersion === "v4" &&
                  FlagsPermissionBookingV4.permission_redirect_booking_duplicate_v4.isEnabled()
                ) {
                  this.$router.push({ path: `/booking-v2/${item.sttNo}/create-v4` });
                  return;
                }
                this.$router.push({ path: `/booking-v2/${item.sttNo}/create` });
              }
            },
            {
              icon: "duplicate",
              iconV2: true,
              id: "client",
              label: this.$t("bookingShipmentV2.action.duplicateClient"),
              textColor: "gray-lp-300",
              iconColor: "gray-lp-600",
              sizeIcon: "w-5",
              clickFunction: async () => {
                if (
                  item.bookingFormVersion === "v4" && 
                  FlagsPermissionBookingV4.permission_redirect_booking_duplicate_v4.isEnabled()
                ) {
                  this.$router.push({ path: `/booking-v2/${item.sttNo}/create-client-v4` });
                  return;
                }
                this.$router.push({
                  path: `/booking-v2/${item.sttNo}/create-client`
                });
              }
            }
          ].filter((option) => this.filterDuplicateOptions(option, item));

          if (!groupOptions.length) return false;

          return {
            outline: true,
            iconV2: true,
            icon: "duplicate",
            textColor: "red-lp-100",
            color: "red-lp-100",
            clickFunction: () => null,
            groupOptionsClass: "w-64 text-red-lp-100",
            groupOptions
          };
        }
      },
      {
        name: "",
        key: "button_column",
        styleHead: "w-24 text-left",
        styleButton: (item: ShipmentBooking) => ({
          outline: true,
          iconV2: true,
          icon: "option",
          textColor: "gray-lp-600",
          color: "gray-lp-600",
          clickFunction: () => null,
          groupOptionsClass: "w-56 text-gray-lp-400",
          groupOptions: this.actionGroupOptions(item)
        })
      }
    ];
  }

  filterDuplicateOptions(
    option: { id: string },
    item: ShipmentBooking
  ): boolean {
    if (/^88LP/i.test(item.sttNo)) {
      return option.id === "client" && /^(AP|AS)/i.test(item.sttShipmentId);
    }

    if (!this.isAccountPOS) return option.id !== "retail";
    return true;
  }

  // Table
  get columns() {
    return [
      ...this.columnsOne,
      ...this.columnsTwo,
      ...this.columnThree,
      ...this.columnAction
    ];
  }

  notification = false;
  setNotification() {
    this.notification = false;

    setTimeout(() => {
      this.notification = true;
    }, 10);
  }

  get isEditable(): boolean {
    return this.isMigratingFromElexys || !this.isEditAble;
  }

  renderDfod(cod: boolean, dfod: boolean) {
    const result = {
      is: false,
      label: "-"
    };

    if (cod && dfod) {
      (result.is = true), (result.label = "DFOD");
    } else if (cod && !dfod) {
      (result.is = true), (result.label = "COD");
    }

    return result;
  }

  renderCodType(data: ShipmentBooking) {
    const newCod = this.renderDfod(data.sttIsCod, data.sttIsDfod);

    const isCod = { is: newCod.is, label: newCod.label };
    const isPad = { is: data.sttIsPad, label: "PAD" };
    const sttCodType = [] as string[];
    [isCod, isPad].forEach((e: any) => {
      if (e.is) {
        sttCodType.push(e.label);
      }
    });
    return sttCodType.length
      ? sttCodType
          .map((stt) =>
            ChipsStyles({ status: "gray", title: stt, square: true })
          )
          .join("")
      : "-";
  }

  get isEditAble() {
    return FlagsPermissionBooking.permission_booking_edit.isEnabled();
  }
  isEditAbleBasedOnAccountType(lastStatus: string) {
    if (this.dataProfile.account_type === "internal") {
      return (
        lastStatus !== "CNX" &&
        lastStatus !== "SCRAP" &&
        lastStatus !== "POD" &&
        lastStatus !== "CODREJ"
      );
    }
    return false;
  }
  generateTrackButton(item: ShipmentBooking) {
    return {
      icon: "track",
      label: this.$t("bookingShipment.list.trackShipment"),
      iconV2: true,
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      clickFunction: () =>
        this.$router.push(
          `/shipment/tracking/stt?${
            new QueryParamsEntities2({
              "stt-no": item.sttNo
            }).queryString
          }`
        )
    };
  }

  actionGroupOptions(item: ShipmentBooking) {
    const account = AccountController.accountData.accountIsForeign;
    const language = account || this.isAccountCountryMY ? "en" : "id";

    const thermal = {
      icon: "printer-v2",
      label: this.$t("bookingShipment.list.printThermalResiPdf"),
      iconV2: true,
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      clickFunction: () => this.print(item.sttId, item, "thermal-pdf", language)
    };

    const basicA4 = {
      icon: "print-summary",
      label: this.$t("bookingShipment.list.printResiA4Pdf"),
      iconV2: true,
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      clickFunction: () => this.print(item.sttId, item, "basic", language)
    };
    const invoiceA4 = {
      icon: "print-summary",
      iconV2: true,
      label: this.$t("bookingShipment.list.printCommercialInvoiceA4"),
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      dataTestid: "booking-list-ci-print-a4",
      clickFunction: () =>
        this.printInvoice(
          item.sttId,
          item,
          "commercial-invoice",
          Boolean(item.isNewForm),
          "a4"
        )
    };
    const invoiceA6 = {
      icon: "print-summary",
      iconV2: true,
      label: this.$t("bookingShipment.list.printCommercialInvoiceA6"),
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      dataTestid: "booking-list-ci-print-a6",
      clickFunction: () =>
        this.printInvoice(
          item.sttId,
          item,
          "commercial-invoice",
          Boolean(item.isNewForm),
          "a6"
        )
    };

    const track = {
      icon: "track",
      label: this.$t("bookingShipment.list.trackShipment"),
      iconV2: true,
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      clickFunction: () =>
        this.$router.push(
          `/shipment/tracking/stt?${
            new QueryParamsEntities2({
              "stt-no": item.sttNo
            }).queryString
          }`
        )
    };

    const help = {
      icon: "sto-sc",
      label: this.$t("bookingShipment.list.reportIssue"),
      iconV2: true,
      textColor: "gray-lp-300",
      iconColor: "gray-lp-600",
      sizeIcon: "w-5",
      clickFunction: () => this.goToCreatePusatResolusi(item.sttNo)
    };

    const isInterpackProduct =
      item.sttProductType === "INTERPACK" ||
      item.sttProductType === "INTERPACKMAXI";
    const isInternational = Boolean(item.isInternational);
    const showCommercialInvoice = isInterpackProduct || isInternational;
    const list = [
      thermal,
      basicA4,
      showCommercialInvoice ? invoiceA4 : undefined,
      showCommercialInvoice && item.isNewForm ? invoiceA6 : undefined,
      track
    ];

    const groupOptions =
      this.dataProfile.account_type_detail.type === "pos"
        ? [...list, help]
        : list;

    return groupOptions.filter((e) => e);
  }

  async print(
    sttId: number,
    item: ShipmentBooking,
    type = "",
    language = "id"
  ) {
    const book: any = await import(
      "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
    );
    const printType: any = {
      thermal: () =>
        book.default.methods.printThermal(sttId, language, item.sttNo),
      "thermal-pdf": () =>
        book.default.methods.printBasic(
          sttId,
          0,
          language,
          false,
          true,
          item.sttNo
        ),
      basic: () =>
        book.default.methods.printBasic(
          sttId,
          1,
          language,
          undefined,
          undefined,
          item.sttNo
        )
    };

    printType[type]();
  }

  async printInvoice(sttId: number, item: ShipmentBooking, type = "", isNewForm: boolean, pageSize: "a4" | "a6" = "a4") {
    const book: any = await import(
      "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
    );
    const printType: any = {
      "commercial-invoice": () => {
        if (isNewForm) {
          book.default.methods.directPrintInterpack(sttId, item.sttNo, pageSize);
        } else {
          book.default.methods.directPrintInterpackV1(sttId, item.sttNo);
        }
      }
    };

    printType[type]();
  }

  goToDetail(item: any) {
    this.$router.push({ path: `/booking-v2/${item.sttNo}` });
  }
  goToEdit(id: number, sttNo: string) {
    router.push({ path: `/booking-v2/${sttNo}/edit` });
  }

  goToCreatePusatResolusi(id: string) {
    dataLayer("laporkan_kendala_booking_list_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
    let pusatResolusi = `/pusat-resolusi/create?sttNo=${id}`;
    if (
      FlagsPermissionPusatResolusiV2.permission_pusat_resolusi_buat_kendala.isEnabled()
    ) {
      pusatResolusi = `/pusat-resolusi-v2/create?sttNo=${id}`;
    }
    router.push(pusatResolusi);
  }

  onBookingRetail() {
    this.hitGtmBookingClicked();

    this.goToCreateV3();
  }

  onBookingRetailV4() {
    this.hitGtmBookingClicked();

    this.goToCreateV4();
  }

  goToCreateV3() {
    this.$router.push("/booking-v2/create-v3");
    dataLayer("create_booking_manual_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateClientV3() {
    this.$router.push("/booking-v2/create-client-v3");
    dataLayer("create_booking_client_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateV4() {
    this.$router.push("/booking-v2/create-v4");
    dataLayer("create_booking_manual_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateClientV4() {
    this.$router.push("/booking-v2/create-client-v4");
    dataLayer("create_booking_client_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToCreateShipmentBook() {
    this.$router.push(`/booking-v2/create/by-shipment-id`);
    dataLayer("create_booking_shipment_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  goToInstantBooking() {
    this.tncModal = false;
    InstantBookingController.setIsInstantBookingTncConfirmed(true);
    this.$router.push("/booking-v2/create/instant-booking-shipment");
    dataLayer("create_booking_instant_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  get isCollapseSidebar() {
    return AccountController.isCollapseSidebar;
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  balanceUnderLimit = false;
  get isBalanceUnderLimitForPos() {
    return (
      BalanceController.balanceData.walletBalance <
        this.dataProfile.limit_rule_min_balance &&
      this.dataProfile.account_type === "partner"
    );
  }

  get permissionBookingOtherList() {
    const permissions = [
      {
        status: FlagsPermissionBookingV3.permission_booking_v3_create_markeplace.isEnabled(),
        title: this.$t("bookingShipment.list.bookingAppMarketplace"),
        action: this.goToCreateShipmentBook
      },
      {
        status: FlagsPermissionBookingV4.permission_booking_v4_create_client.isEnabled(),
        title: this.$t("bookingShipment.list.bookingClient"),
        action: this.goToCreateClientV4
      },
      {
        status: FlagsPermissionBookingV3.permission_booking_v3_create_client.isEnabled(),
        title: this.$t("bookingShipment.list.bookingClient"),
        action: this.goToCreateClientV3
      },
      {
        status: FlagsPermissionBookingV3.permission_booking_v3_create_markeplace.isEnabled(),
        title: this.$t("bookingShipment.list.bookingInstant"),
        action: this.goToInstantBooking
      }
    ];

    const result = permissions.filter((item: any) => item.status);
    return {
      data: result,
      title: result[0]?.title,
      action: result[0]?.action,
      total: result.length
    };
  }

  // cancel booking
  isRejectPopup = false;
  sttNumberSelected = "";
  onOpenPopupCancelBooking(item: any) {
    this.sttNumberSelected = item?.sttNo;
    this.isRejectPopup = true;
  }
  hitGtmBookingClicked() {
    dataLayer("create_booking_button_clicked", {}, [
      "timestamp",
      "userType",
      "userId"
    ]);
  }

  get accountIsNonForeign() {
    return !AccountController.accountData.accountIsForeign;
  }

  onCloseTncModal() {
    this.tncModal = false;
  }

  // check last status red color
  checkLastStatusRedColor(status: string): boolean {
    return [
      "DEX",
      "SCRAP",
      "SHORTLAND",
      "MIS-ROUTE",
      "CODREJ",
      "MISSING",
      "DAMAGE",
      "NOT RECEIVE",
      "NOT RECEIVED",
      "MISBOOKING",
      "REJECTED"
    ].includes(status);
  }

  // check last status blue color
  checkLastStatusBlueColor(status: string): boolean {
    return [
      "CNX",
      "POD",
      "RTS",
      "CLAIM",
      "CI",
      "RTSHQ",
      "STT ADJUSTED POD",
      "REROUTE"
    ].includes(status);
  }

  // mapping last status color
  mapLastStatusColor(status: string): string {
    const uppercaseStatus = status.toUpperCase();
    if (this.checkLastStatusBlueColor(uppercaseStatus))
      return "bg-blue-lp-600 text-blue-lp-700";
    if (this.checkLastStatusRedColor(uppercaseStatus))
      return "bg-red-lp-1300 text-red-lp text-red-lp-510";
    return "bg-gray-lp-1400 text-gray-lp-300";
  }

  // mapping adjustment status color
  mapAdjustmentStatusColor(status: string): string {
    if (status === "approved") return "text-green-lp-400";
    if (status === "rejected") return "text-red-lp-500";
    if (status === "waiting") return "text-yellow-lp-500";
    return "";
  }

  // mapping adjustment status text
  mapAdjustmentStatusText(status: string): string {
    if (status === "approved")
      return this.$t("bookingShipment.list.adjustmentAccepted");
    if (status === "rejected")
      return this.$t("bookingShipment.list.adjustmentRejected");
    if (status === "waiting")
      return this.$t("bookingShipment.list.adjustmentPending");
    return "";
  }

  get isCreateButtonV3LionPro() {
    const excludeCountry = ["ID", "MY"].includes(
      AccountController.accountData.countryCode.toUpperCase()
    );

    return (
      FlagsPermissionBookingV3.permission_booking_v3_create_manual.isEnabled() &&
      !excludeCountry
    );
  }

  get isCreateButtonV4LionPro() {
    const excludeCountry = ["ID", "MY"].includes(
      AccountController.accountData.countryCode.toUpperCase()
    );

    return (
      FlagsPermissionBookingV4.permission_booking_v4_create_manual.isEnabled() &&
      !excludeCountry
    );
  }

  get createBookingClientAccount() {
    return (
      AccountController.accountData.isAllClient ||
      AccountController.accountData.isInternalAccount
    );
  }

  get isCreateButtonV4Client() {
    return FlagsPermissionBookingV4.permission_booking_v4_create_client.isEnabled();
  }

  get copyStyles() {
    return {
      background: "bg-gray-lp-300",
      text: "text-white",
      message: this.$t("bookingShipment.list.copySttSuccess"),
      width: "w-300px"
    };
  }

  pickupCorporateSummary = new PickupCorporateSummary();
  async fetchSummaryListPickupV2() {
    if (!this.isClient) return;

    this.pickupCorporateSummary = await ListPickupV2Controller.getPickupCorporateSummary(
      new PickupCorporateSummaryRequest()
    );
  }

  addressPrefetchPromise: Promise<void> | null = null;

  get selectedAddress(): PickupCorporateAddress {
    return PickupScheduleController.selectedAddress;
  }

  updateListPickupCorporateAddress(selectAddress = true): Promise<void> {
    return PickupScheduleController.getListPickupCorporateAddress(
      new ApiRequestList({
        page: 1,
        limit: 50,
        isTotalData: false,
        selectAddress
      })
    );
  }

  async onOpenSavedAddressList(): Promise<void> {
    if (!this.addressPrefetchPromise) {
      this.addressPrefetchPromise = this.updateListPickupCorporateAddress();
    }
    await this.addressPrefetchPromise;
    this.isChangeAddressOpen = true;
  }

  onSelectAddress(address: PickupCorporateAddress): void {
    PickupScheduleController.setSelectedAddressPickupCorporateAddress(address);
    this.patchSummaryAddress(address);
  }

  async onDefaultAddressChanged(): Promise<void> {
    await this.updateListPickupCorporateAddress(false);
    const defaultAddress = PickupScheduleController.listPickupCorporateAddress.find(
      (address) => address.pcaIsDefault
    );
    if (defaultAddress?.pcaId) {
      this.patchSummaryAddress(defaultAddress);
    }
  }

  async onAddressFormSuccess(
    payload: AddressFormSuccessPayload
  ): Promise<void> {
    const selectAddress = payload.isDefault || !this.selectedAddress.pcaId;
    await this.updateListPickupCorporateAddress(selectAddress);
    await this.syncSummaryAddress();
    this.closeModalAddAddress();
  }

  async onAddressDeleted(): Promise<void> {
    const previousSelectedId = this.selectedAddress.pcaId;
    await this.updateListPickupCorporateAddress(false);

    const selectedStillExists =
      !!previousSelectedId && this.selectedAddress.pcaId === previousSelectedId;

    if (!selectedStillExists) {
      const defaultAddress = PickupScheduleController.listPickupCorporateAddress.find(
        (address) => address.pcaIsDefault
      );
      if (defaultAddress?.pcaId) {
        PickupScheduleController.setSelectedAddressPickupCorporateAddress(
          defaultAddress
        );
        this.patchSummaryAddress(defaultAddress);
        return;
      }
    }

    await this.syncSummaryAddress();
  }

  patchSummaryAddress(address: PickupCorporateAddress): void {
    this.pickupCorporateSummary = patchPickupSummaryAddress(
      this.pickupCorporateSummary,
      address
    );
  }

  async syncSummaryAddress(): Promise<void> {
    if (this.selectedAddress.pcaId) {
      this.patchSummaryAddress(this.selectedAddress);
      return;
    }
    await this.fetchSummaryListPickupV2();
  }

  openModalSttPickupList = false;
  openModalPickupRequestSuccess = false;
  openModalRequestPickup = false;
  isChangeAddressOpen = false;
  isActivePickupWarningOpen = false;

  pickupSuccess = {
    orderId: "",
    totalKoli: 0,
    totalWeightKg: 0,
    pickupDate: "",
    pickupTimeStart: "",
  };
  onRequestPickup() {
    if (this.pickupCorporateSummary.activePickupCount) {
      this.isActivePickupWarningOpen = true;
      return;
    }

    this.onOpenModalRequestPickup();
  }

  onOpenModalRequestPickup() {
    this.isActivePickupWarningOpen = false;

    this.openModalRequestPickup = true;
  }

  onOpenModalRequestPickupManual() {
    this.isActivePickupWarningOpen = false;

    this.openModalRequestPickup = true;
  }

  onRequestPickupSuccess(payload: PickupSuccessPayload) {
    this.openModalRequestPickup = false;
    this.pickupSuccess = payload;
    this.openModalPickupRequestSuccess = true;

    this.fetchSummaryListPickupV2();

    if (this.pagination) {
      this.pagination.page = 1;
    }
    this.onRequest();
  }

  onCloseModalPickupRequestSuccess() {
    this.openModalPickupRequestSuccess = false;
    this.fetchSummaryListPickupV2();
  }

  onViewStt() {
    const refs: any = this.$refs["advancedFilterListBookingV2"];
    refs?.resetToDefaultFilter?.({ isViewStt: true });
  }

  get requestPickupMode(): PickupRequestMode {
    if (this.pickupCorporateSummary.state === "none") {
      return "blank";
    }

    return this.pickupCorporateSummary.state as PickupRequestMode;
  }

  get requestPickupPrefill(): any {
    const s = this.pickupCorporateSummary;
    if (s.state === "suggestion" || s.state === "none") return null;
    return {
      sttCount: s.sttCount,
      koli: s.koliCount,
      weight: s.weightKg,
      specialHandling: s.specialHandling,
      serviceCodes: s.productTypes,
      addressId: s.defaultAddressId
    };
  }

  onViewPickup() {
    this.$router.push({
      name: "list-pickup-v2",
      query: {
        summary_filter: "active_pickup"
      }
    });
  }

  get isClient() {
    return AccountController.accountData.isAllClient;
  }

  get isAccountCountryMY() {
    return (
      AccountController.accountData.account_type_detail.countryCode?.toLowerCase() ===
      "my"
    );
  }

  get isInternalAccount() {
    return AccountController.accountData.isInternalAccount;
  }

  get nestedstatus() {
    return GET_NESTED_STATUS_OPTIONS({
      isAccountCountryMY: this.isAccountCountryMY,
      isInternalAccount: this.isInternalAccount
    });
  }

  hydrateFromQuery(query = this.$route.query) {
    const preset = parseSummaryFilterQuery(query);

    if (preset !== PRESET_ONGOING) {
      this.onRequest();
      return;
    }

    ShipmentBookingController.setSttCorporate(true);

    const filter = applyOngoingFilterToAdvanceFilterData(
      this.advancedFilterData,
      this.nestedstatus
    );

    const refs: any = this.$refs["advancedFilterListBookingV2"];
    refs?.onSetNestedStatus?.(filter.nestedStatus);
    refs?.applyFilter?.({ isFromLisPickup: true });
  }

  onUpdateQuery(isFromLisPickup = false) {
    ShipmentBookingController.setSttCorporate(isFromLisPickup);

    if (!isFromLisPickup) return;

    const isOngoing = isEqual(
      this.advancedFilterData.nestedStatus,
      this.nestedstatus[0].children.map((x) => x.value)
    );

    const query = {
      ...this.$route.query
    };

    if (isOngoing) {
      query.summary_filter = PRESET_ONGOING;
    } else {
      delete query.summary_filter;
    }

    this.$router.replace({
      query
    });
  }

  onResetQuery(isViewStt = false) {
    const query = {
      ...this.$route.query
    };

    delete query.summary_filter;

    this.$router.replace({
      query
    });

    ShipmentBookingController.setSttCorporate(
      isViewStt && !ShipmentBookingController.isSttCorporate
    );
  }

  isAddAddress = false;

  showModalAddAddress() {
    this.isAddAddress = true;
  }

  closeModalAddAddress() {
    this.isAddAddress = false;
  }
}

export default TabListBooking;
